import { render } from "./ListSize.vue?vue&type=template&id=f0e32646&scoped=true&ts=true"
import script from "./ListSize.vue?vue&type=script&lang=ts"
export * from "./ListSize.vue?vue&type=script&lang=ts"

import "./ListSize.vue?vue&type=style&index=0&id=f0e32646&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0e32646"]])

export default __exports__